import script from "./VipCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./VipCard.vue?vue&type=script&lang=ts&setup=true"

import "./VipCard.vue?vue&type=style&index=0&id=e327a670&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e327a670"]])

export default __exports__